import { ArrayOps } from '../lift';
export function filter(predicate) {
    var arr = this.value(), result = [];
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (predicate(item, i))
            result.push(item);
    }
    return new ArrayOps(result);
}
ArrayOps.prototype.filter = filter;
